import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
	"inline-flex items-center rounded-full border px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.14em]",
	{
		variants: {
			variant: {
				default: "border-border bg-secondary text-secondary-foreground",
				success: "border-emerald-200 bg-emerald-50 text-emerald-700",
				warning: "border-amber-200 bg-amber-50 text-amber-700",
				danger: "border-rose-200 bg-rose-50 text-rose-700",
				info: "border-sky-200 bg-sky-50 text-sky-700",
			},
		},
		defaultVariants: {
			variant: "default",
		},
	},
);

export interface BadgeProps
	extends React.HTMLAttributes<HTMLDivElement>,
		VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
	return (
		<div className={cn(badgeVariants({ variant }), className)} {...props} />
	);
}
